import { mutationTypes, actionTypes } from '@/types';

export default function addToMediaObjectMap({ commit, dispatch }, { mediaObjectArray }) {
	commit(mutationTypes.addToMediaObjectMap, { mediaObjectArray });
	dispatch(actionTypes.videoPlayQueued);
}
